/* DIX 2026 — Badge « Canada + États-Unis » à gauche du logo, pour équilibrer l'en-tête.
   Drapeaux en SVG plutôt qu'en emoji : Windows n'affiche pas les emojis de drapeau
   (il les remplace par les lettres CA / US). */
(function () {
  var CSS = '.dsd-ship{display:inline-flex;align-items:center;gap:5px;padding:4px 9px;border:1px solid rgba(212,175,106,.38);border-radius:999px;background:linear-gradient(150deg,rgba(212,175,106,.12),rgba(212,175,106,.03));vertical-align:middle;line-height:0;transition:border-color .25s}'
    + '.dsd-ship:hover{border-color:rgba(212,175,106,.75)}'
    + '.dsd-ship svg{display:block;width:17px;height:11px;border-radius:2px;box-shadow:0 0 0 .5px rgba(0,0,0,.35)}'
    + '.dsd-hleft{display:flex;align-items:center;gap:11px}'
    + '@media(max-width:749px){.dsd-ship{padding:3px 7px;gap:4px}.dsd-ship svg{width:15px;height:10px}.dsd-hleft{gap:8px}}';

  var CA = '<svg viewBox="0 0 24 16" aria-hidden="true"><rect width="24" height="16" fill="#fff"/><rect width="6" height="16" fill="#d52b1e"/><rect x="18" width="6" height="16" fill="#d52b1e"/><path fill="#d52b1e" d="M12 3.2l.9 1.9 2-.5-.7 1.9 1.3.6-1.6 1.3.3 1-2-.3.1 2.3h-.6l.1-2.3-2 .3.3-1L8.5 7.1l1.3-.6-.7-1.9 2 .5z"/></svg>';
  var US = '<svg viewBox="0 0 26 16" aria-hidden="true"><rect width="26" height="16" fill="#fff"/><g fill="#b22234"><rect width="26" height="1.23"/><rect y="2.46" width="26" height="1.23"/><rect y="4.92" width="26" height="1.23"/><rect y="7.38" width="26" height="1.23"/><rect y="9.84" width="26" height="1.23"/><rect y="12.3" width="26" height="1.23"/><rect y="14.76" width="26" height="1.24"/></g><rect width="11" height="8.61" fill="#3c3b6e"/></svg>';

  function label() {
    var l = (document.documentElement.lang || 'fr').toLowerCase();
    return l.indexOf('en') === 0 ? 'We ship to Canada and the United States' : 'Livraison au Canada et aux États-Unis';
  }

  function build() {
    var s = document.createElement('span');
    s.className = 'dsd-ship';
    s.setAttribute('title', label());
    s.setAttribute('aria-label', label());
    s.innerHTML = CA + US;
    return s;
  }

  function place() {
    if (document.querySelector('.dsd-ship')) return true;

    /* Accueil : grille [menu] [logo] [droite]. On enveloppe le bouton menu et le badge
       dans une seule cellule pour ne pas casser la grille à trois colonnes. */
    var hbtn = document.querySelector('.hwrap > .hbtn');
    if (hbtn && hbtn.parentElement) {
      var wrap = document.createElement('div');
      wrap.className = 'dsd-hleft';
      hbtn.parentElement.insertBefore(wrap, hbtn);
      wrap.appendChild(hbtn);
      wrap.appendChild(build());
      return true;
    }

    /* Autres pages : à côté de l'icône de recherche, dans la zone gauche de l'en-tête. */
    var search = document.querySelector('header .header__icon--search, header details-modal .header__icon');
    if (search && search.parentElement) {
      search.parentElement.insertBefore(build(), search.nextSibling);
      return true;
    }

    var loc = document.querySelector('.desktop-localization-wrapper');
    if (loc && loc.parentElement) {
      loc.parentElement.insertBefore(build(), loc);
      return true;
    }
    return false;
  }

  /* Signature du fondateur : « par Jay » → « par Jay Fortin » (le texte vit dans une
     section trop volumineuse pour être réécrite proprement par l'API). */
  function fixName() {
    var el = document.querySelector('.ssub');
    if (!el) return;
    var t = el.textContent;
    if (t && t.indexOf('Jay Fortin') === -1) {
      el.textContent = t.replace(/\bJay\b/, 'Jay Fortin');
    }
  }

  function start() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    fixName();
    if (place()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      fixName();
      if (place() || tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
